import React from 'react';
import { MedicationRequestOutputDto } from 'graphql/generated/remote-schema-hasura';
import ButtonComponent from 'components/button/buttonComponent';
import { ReactComponent as ChevronLeftIcon } from 'assets/icons/chevron-left.svg';
import moment from 'moment/moment';
import { MEDICATION_DATE_FORMAT } from '../../../../../../../utilities/dateHelper';

const Row: React.FC<{ label: string; value: string | React.ReactNode }> = ({
  label,
  value,
}) => {
  return (
    <div className="flex gap-5 justify-start items-start">
      <div className="min-w-[80px] w-20 justify-start text-charcoal-gray text-sm font-semibold leading-5">
        {label}
      </div>
      <div className="flex-1 text-right justify-start text-med-gray-3 text-sm font-medium leading-5">
        {value}
      </div>
    </div>
  );
};

const MedicationMobile: React.FC<{
  medication: MedicationRequestOutputDto;
  locale: Record<string, string>;
  setAddress: (address: string) => void;
}> = ({ medication, locale, setAddress }) => {
  const {
    ndc,
    displayName,
    activeIngredUnit,
    activeNumeratorStrength,
    quantity,
    expectedSupplyDuration,
    requestedAt,
    pharmacyAddress,
  } = medication;

  const start = moment(requestedAt).format(MEDICATION_DATE_FORMAT);
  const end = moment(requestedAt)
    .subtract(-1 * Number(expectedSupplyDuration?.value || 0), 'days')
    .format(MEDICATION_DATE_FORMAT);

  return (
    <div className="flex py-5 mx-5 flex-col gap-2.5 border-b border-b-gray-opacity-15 last-of-type:border-b-transparent desktop:hidden">
      <Row
        label={'Medication'}
        value={
          <>
            <p>{displayName}</p>
          </>
        }
      />
      <Row
        label={locale?.strength || 'Strength'}
        value={activeNumeratorStrength || '-'}
      />
      <Row
        label={locale?.days || 'Days Supply'}
        value={expectedSupplyDuration?.value ?? '-'}
      />
      <Row
        label={locale?.quantity || 'Quantity'}
        value={quantity?.value || '-'}
      />
      <Row
        label={locale?.dosageForm || 'Dosage Form'}
        value={activeIngredUnit ?? '-'}
      />
      <Row label={locale?.nds || 'NDC'} value={ndc ?? '-'} />

      <Row label={locale.duration} value={`${start} - ${end}`} />
      {pharmacyAddress && (
        <Row
          label={locale?.pharmacy || 'Pharmacy'}
          value={
            <>
              <ButtonComponent
                testID={`pharmacy-${ndc}`}
                type="underline"
                className="!text-xs my-auto !w-auto"
                iconPosition="right"
                containerClassName="!text-xs"
                onClick={() => setAddress(pharmacyAddress)}
                Icon={() => (
                  <ChevronLeftIcon className="w-[6px] h-[12px] rotate-180" />
                )}
              >
                Show on Map
              </ButtonComponent>
            </>
          }
        />
      )}
    </div>
  );
};

export default MedicationMobile;
